import { Link } from "react-router-dom";
import { caseCategories, cases } from "@/mocks/cases";

const CategoryGrid = () => (
  <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-8 md:mb-12">
        <p className="text-sm font-medium text-primary-600 mb-2">分类档案</p>
        <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
          塌房也分类型
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          不同的塌房背后，翻车的逻辑并不一样。按类型归档，能更快找到你想看的那一类旧料。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {caseCategories.map((cat, index) => {
          const count = cases.filter((c) => c.category === cat.key).length;
          const featured = index === 0;
          return (
            <Link
              key={cat.key}
              to={`/cases?category=${encodeURIComponent(cat.key)}`}
              className={`group flex flex-col p-5 md:p-7 rounded-lg border transition-colors ${
                featured
                  ? "bg-accent-500 border-accent-500 sm:col-span-2 lg:col-span-1"
                  : "bg-background-50 border-background-200/80 hover:border-primary-300"
              }`}
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-md text-2xl mb-4 ${
                  featured
                    ? "bg-background-50/20 text-background-50"
                    : "bg-primary-100 text-primary-600"
                }`}
              >
                <i className={cat.icon} />
              </span>
              <h3
                className={`font-heading font-bold text-lg ${
                  featured ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {cat.name}
              </h3>
              <p
                className={`mt-2 text-sm leading-relaxed flex-1 ${
                  featured ? "text-accent-50" : "text-foreground-600"
                }`}
              >
                {cat.desc}
              </p>
              <span
                className={`mt-5 inline-flex items-center gap-1 text-sm font-medium ${
                  featured
                    ? "text-background-50"
                    : "text-foreground-700 group-hover:text-primary-600"
                } transition-colors`}
              >
                {count} 起在档
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          );
        })}

        <div className="flex flex-col justify-center p-5 md:p-7 rounded-lg border border-dashed border-background-300 bg-background-50/60">
          <h3 className="font-heading font-bold text-lg text-foreground-950">
            没找到对应分类？
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            翻车方式千奇百怪，如果你遇到的事件不属于以上任何一类，欢迎投稿，我们会评估后开设新的档案类目。
          </p>
          <Link
            to="/about#submit"
            className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            去投稿线索
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default CategoryGrid;